declare global {
    const APP_ELECTRON: boolean;
}

export const isNative = APP_ELECTRON || (typeof window !== 'undefined' && Boolean(window.electron));

export const isRenderer = APP_ELECTRON && typeof window !== 'undefined' && Boolean(window.electron);

export const isMain = APP_ELECTRON && typeof window === 'undefined';
